import { FrontSide, Mesh, TextureLoader } from "three";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema4/GLB_T4_Billetes.glb";
import { imgsTopic4 } from "../../../../../assets/imgs/Tema4/index";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class Billetes extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11, -0.3, -1.5);
		this.rotation.set(0.6, -0, -1.6);
		this.scale.set(4, 1, 4);
		// this.helpers()
		this.listenersobserver()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.Billetes = gltf.scene.getObjectByName("Billetes", true);
		})
	}
	updateMaterialScreen(img) {
		const newTexture = new TextureLoader().load(img);
		const object = this.Billetes;
		object.material.map = newTexture
		object.material.side = FrontSide
		// object.material.toneMapped = false;
	}
	listenersobserver() {
		ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.changebilletsTexture, () => {
			this.updateMaterialScreen(imgsTopic4.textureBillets_20)
		});
		// ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.changebilletsTexture, () => {
		// 	this.updateMaterialScreen(imgsTopic4.textureBillets_50)
		// });
		// ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.changebilletsTexture, () => {
		// 	this.updateMaterialScreen(imgsTopic4.textureBillets_100)
		// });
		// ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.changebilletsTexture, () => {
		// 	this.updateMaterialScreen(imgsTopic4.textureBillets_200)
		// });
		// ObserverEmitter.on(EVENTS.tema4.subtopicFour.activityThree.changebilletsTexture, () => {
		// 	this.updateMaterialScreen(imgsTopic4.textureBillets_500)
		// });
	}
	helpers() {
		const gui = new GUI();
		const escanerFolder = gui.addFolder("Billetes");
		escanerFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		escanerFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		escanerFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		escanerFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		escanerFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		escanerFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		escanerFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		escanerFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		escanerFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		escanerFolder.add(this, "visible").name("visible");
	}
	helpersChild() {
		// this.helpersMethod("CPU", this.Cpu);
	}
	helpersMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		const limit = 20;
		folferMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}
	onAnimate() {
		this.clearAnimation()
		this.Billetes.animation = gsap.to(this.Billetes.rotation, {
			y: 1.56,
			x: 3.14,
			yoyo: true,
			repeat: -1,
			duration: 5,
			ease: "none",
		});
	}
	clearAnimation() {
		if (this.Billetes.animation) {
			this.Billetes.animation.kill();
			this.Billetes.rotation.set(0, 0, 0);
		}
	}
	onClose() {
		this.clearAnimation()
		this.Billetes.animation = gsap.to(this.Billetes.position, {
			x: -0.02,
			duration: 0.3,
			ease: "none",
		});
	}
	onFurther() {
		this.clearAnimation()
		this.Billetes.animation = gsap.to(this.Billetes.position, {
			x: 0,
			duration: 0.3,
			ease: "none",
		});
	}
}